import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import LinearProgress from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';

const PREFIX = 'ItemsListSkeleton';
const classes = {
  root: `${PREFIX}-root`,
  contained: `${PREFIX}-contained`,
  progressContainer: `${PREFIX}-progressContainer`,
  progress: `${PREFIX}-progress`,
  rows: `${PREFIX}-rows`,
  spinner: `${PREFIX}-spinner`,
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  [`&.${classes.root}`]: {
    width: '100%',
    marginTop: 20
  },
  [`&.${classes.contained}`]: {
    marginTop: '0 !important',
    borderRadius: 0,
  },
  [`& .${classes.progressContainer}`]: {
    padding: '11px 16px 11px 16px'
  },
  [`& .${classes.progress}`]: {
    background: theme.palette.skeletonBlock,
    padding: '10px',
    margin: '10px',
    // ly-skeleton-pulse is in index.css, with the app's other keyframes
    animation: 'ly-skeleton-pulse 1.4s ease-in-out infinite',
  },
  [`& .${classes.rows}`]: {
    position: 'relative',
  },
  [`& .${classes.spinner}`]: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
  },
  '@media (prefers-reduced-motion: reduce)': {
    [`& .${classes.progress}`]: {
      animation: 'none',
    },
  },
}));

class ItemsListSkeleton extends React.Component {
  render() {
    // showSpinner is opt-in because most pages already have the LoadingIndicator overlay up while
    // a skeleton shows, and its spinner is the one the user should see. Two is worse than one
    const { rows, contained, showSpinner } = this.props;

    let listItems = [];
    for(let i = 0; i < rows; i++) {
      listItems.push(
        <div key={`placeholder-${i}-${rows}`}>
          <div className={classes.progressContainer}>
            <div className={classes.progress}>

            </div>
          </div>
          <Divider />
        </div>
      )
    }

    return (
      <StyledPaper className={classNames(classes.root, contained ? classes.contained : null)} elevation={contained ? 0 : 1}>
        {!this.props.hideTopToolbar &&
          <Toolbar>
            <div className={classes.progressContainer} style={{padding: 0, width: '10%'}}>
              <div className={classes.progress}>

              </div>
            </div>
          </Toolbar>
        }
        <Divider />
        <div className={classes.rows}>
          <List style={{padding: 0}}>
          {listItems}
          </List>
          {showSpinner && <CircularProgress className={classes.spinner} size={28} thickness={4} />}
        </div>

        {!this.props.hideBottomToolbar && <Toolbar />}
      </StyledPaper>
    );
  }
}

export default ItemsListSkeleton;
